// updateEngagementData.js
'use strict';
import { MERGE_OPERATION_DATA, PERSIST_NOW } from '../ActionTypes.js';
import { engagement as engagementDebug } from '../resource/debug.js';

import { restoreHook } from '../component/PersistMiddlewareLoader.jsx';

export const defaultStashedData = {
  playerType: '',
  playerSource: '',
  mode: null,
  startTime: null,
  giftTime: null,
  giftState: '',
  isFree: null,
  isNewlyUnlocked: null,
  viewScope: '',
  mediaType: '',
  messageId: '',
  hasViewerCameraVideo: null,
  hasViewerCameraAudio: null,
  exclusivePrivatePrice: null,
};
const engagementLog = engagementDebug.extend('log:MediaEngagementMonitor');

/**
 * Update engagement data
 * @kind action
 * @param {string} playerType - player type ('livestream', 'vod')
 * @param {boolean} isPlaying - is playing
 * @param {boolean} isPlayerVisible - is player visible
 * @param {string} playerSource - player source
 * @param {boolean} isFree - is free
 * @param {boolean} isNewlyUnlocked - is newly unlocked
 * @param {string} viewScope - view scope
 * @param {string} mediaType - media type
 * @param {string} messageId - message id
 * @param {number} giftTime - gift time
 * @param {string} creatorId - creator id
 * @param {string} creatorUsername - creator username
 * @param {object} stashedData - stashed data
 * @return {Promise} Action promise.
 */
const updateEngagementData =
  ({
    playerType,
    isPlaying,
    isPlayerVisible,
    playerSource,
    isFree,
    isNewlyUnlocked,
    viewScope,
    mediaType,
    messageId,
    giftTime,
    creatorId,
    creatorUsername,
    stashedData,
    heartbeatTime,
  }) =>
  async dispatch => {
    const selectPath = ['engagement'];
    const data = {
      stashedData,
      playerType,
      isPlaying,
      isPlayerVisible,
      playerSource,
      giftTime,
      creatorId,
      creatorUsername,
      heartbeatTime,
      isFree,
      isNewlyUnlocked,
      viewScope,
      mediaType,
      messageId,
    };

    Object.keys(data).forEach(key => {
      if (data[key] === undefined) {
        delete data[key];
      }
    });
    engagementLog('updateEngagementData()', { data });

    // to prevent new stashed data from being overwritten by indexedDB
    if (stashedData?.startTime && restoreHook.promise) {
      engagementLog('updateEngagementData() before hook', {
        data,
        promise: restoreHook.promise,
      });
      await restoreHook.promise;
      engagementLog('updateEngagementData() after hook', { data });
    }

    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath,
        data,
      },
    });
    dispatch({ type: PERSIST_NOW });
  };

export default updateEngagementData;
